// extracted by mini-css-extract-plugin
module.exports = {"inlineAd":"pV","innerWrapper":"qV","tooltipWrapper":"rV","icon":"sV","tooltip":"tV","content":"uV"};